import React from 'react';
import cn from 'classnames';
import styles from './keto-container.module.css';
import { ContainerProps } from '../../components/container';

export default function KetoContainer({
  children,
  className,
  variant = 'container',
  ...props
}: ContainerProps) {
  return (
    <div {...props} className={cn(className, styles[variant], 'container')}>
      {children}
    </div>
  );
}
